import api from "./axiosInstance";

export const getClearanceProducts = async ({
  halaman,
  jumlah,
  keyword,
  token
}) => {
  const res = await api.get(
    `${process.env.REACT_APP_ERP_URL}api_web/controler/hoops/clearance.php`,
    {
      params: {
        index: 1,
        halaman,
        jumlah,
        keyword,
      },
      headers: {
        Authorization: token,
      },
    }
  );

  return res.data;
};